import React, { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BackButton from "../../../../BaseComponents/BackButton";
import BaseButton from "../../../../BaseComponents/BaseButton";
import { notFound } from "../../../../Constant";
import { holidayLabel } from "../../../../Constant/HR_HolidayTemplate/holidayTemplate";
import { checkStatusCodeSuccess } from "../../../../Constant/common";
import { shiftSettingLabel } from "../../../../Constant/HR/ShiftSetting";
import { editManageStaff, manageStaffList } from "../../../../Api/HRshiftSetting";
import { useSelectedCenter } from "../../../CenterContext";
import { usePageLoader } from "../../../../_helper/loading/LoadingContext";
import { UserCheck, UserX, Search, AlertCircle, Check, Clock } from "react-feather";

const AVATAR_GRADIENTS = [
  "linear-gradient(135deg,#6366f1,#8b5cf6)",
  "linear-gradient(135deg,#f59e0b,#ef4444)",
  "linear-gradient(135deg,#10b981,#06b6d4)",
  "linear-gradient(135deg,#8b5cf6,#ec4899)",
  "linear-gradient(135deg,#06b6d4,#6366f1)",
];

const getInitials = (name = "") =>
  name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2) || "?";

const StaffPanel = ({
  title,
  icon: Icon,
  iconColor,
  iconBg,
  items,
  searchValue,
  onSearch,
  onCheckAll,
  allChecked,
  onToggle,
  emptyMsg,
  variant = "with",
}) => {
  const isWith = variant === "with";
  const checkedCount = items.filter((s) => s.selected).length;
  return (
    <div
      style={{
        background: "var(--glass-bg)",
        border: "1px solid var(--glass-border)",
        borderRadius: 16,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "14px 18px",
          borderBottom: "1px solid var(--glass-border)",
          background: "rgba(99,102,241,0.02)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 34,
              height: 34,
              borderRadius: 9,
              background: iconBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon size={16} strokeWidth={2} style={{ color: iconColor }} />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: "0.9375rem", color: "var(--text-primary)" }}>
              {title}
            </div>
            <div style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>
              {isWith ? `${items.length} assigned` : `${checkedCount}/${items.length} selected`}
            </div>
          </div>
        </div>
        {!isWith && (
          <button
            type="button"
            onClick={onCheckAll}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "5px 12px",
              borderRadius: 8,
              fontSize: "0.75rem",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.15s",
              border: `1px solid ${allChecked ? "rgba(99,102,241,0.3)" : "var(--glass-border)"}`,
              background: allChecked ? "rgba(99,102,241,0.1)" : "var(--icon-btn-bg)",
              color: allChecked ? "var(--brand-indigo)" : "var(--text-secondary)",
            }}
          >
            {allChecked && <Check size={12} strokeWidth={3} />}
            {allChecked ? "Deselect All" : "Select All"}
          </button>
        )}
      </div>
      <div style={{ padding: "10px 14px", borderBottom: "1px solid var(--glass-border)" }}>
        <div style={{ position: "relative" }}>
          <Search
            size={13}
            strokeWidth={2}
            style={{
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
              color: "var(--text-muted)",
              pointerEvents: "none",
            }}
          />
          <input
            type="text"
            placeholder={holidayLabel.searchStaff}
            value={searchValue}
            onChange={(e) => onSearch(e.target.value)}
            ref={(el) => {
              if (el) el.style.setProperty("padding-left", "30px", "important");
            }}
            style={{
              width: "100%",
              padding: "7px 10px",
              borderRadius: 8,
              border: "1px solid var(--glass-border)",
              background: "var(--icon-btn-bg)",
              color: "var(--text-primary)",
              fontSize: "0.8125rem",
              outline: "none",
            }}
          />
        </div>
      </div>
      <div style={{ maxHeight: 320, overflowY: "auto" }}>
        {items.length === 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "32px 20px",
              gap: 8,
            }}
          >
            <AlertCircle size={28} style={{ color: "var(--text-muted)", opacity: 0.4 }} />
            <p style={{ color: "var(--text-muted)", margin: 0, fontSize: "0.8125rem" }}>
              {emptyMsg}
            </p>
          </div>
        ) : (
          items.map((staff, i) => {
            const gradient =
              AVATAR_GRADIENTS[(staff.name?.charCodeAt(0) || i) % AVATAR_GRADIENTS.length];
            return (
              <div
                key={staff.id}
                onClick={() => onToggle(staff)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "10px 16px",
                  cursor: "pointer",
                  borderBottom: i < items.length - 1 ? "1px solid var(--glass-border)" : "none",
                  background: !isWith && staff.selected ? "rgba(99,102,241,0.04)" : "transparent",
                  transition: "background 0.15s",
                }}
                onMouseEnter={(e) => {
                  if (isWith || !staff.selected)
                    e.currentTarget.style.background = "var(--nav-hover)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background =
                    !isWith && staff.selected ? "rgba(99,102,241,0.04)" : "transparent";
                }}
              >
                {!isWith && (
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: 5,
                      flexShrink: 0,
                      transition: "all 0.15s",
                      background: staff.selected ? "var(--brand-indigo)" : "transparent",
                      border: `1.5px solid ${staff.selected ? "var(--brand-indigo)" : "var(--glass-border)"}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: staff.selected ? "0 2px 8px rgba(99,102,241,0.4)" : "none",
                    }}
                  >
                    {staff.selected && <Check size={11} strokeWidth={3} color="#fff" />}
                  </div>
                )}

                {/* Avatar */}
                <div
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: 10,
                    flexShrink: 0,
                    background: gradient,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ fontSize: "0.75rem", fontWeight: 800, color: "#fff" }}>
                    {getInitials(staff.name)}
                  </span>
                </div>

                <span
                  style={{
                    fontSize: "0.875rem",
                    fontWeight: !isWith && staff.selected ? 600 : 400,
                    color: "var(--text-primary)",
                    flex: 1,
                  }}
                >
                  {staff.name}
                </span>
                {!staff.isActive && (
                  <span
                    style={{
                      padding: "2px 8px",
                      borderRadius: 999,
                      fontSize: "0.625rem",
                      fontWeight: 700,
                      background: "rgba(244,63,94,0.1)",
                      color: "#f43f5e",
                    }}
                  >
                    {holidayLabel.Deactive}
                  </span>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

const ManageShiftStaff = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [withShift, setWithShift] = useState([]);
  const [withoutShift, setWithoutShift] = useState([]);
  const [searchWith, setSearchWith] = useState("");
  const [searchWithout, setSearchWithout] = useState("");
  const [btnLoader, setBtnLoader] = useState(false);
  const { selectedCenterPayload } = useSelectedCenter();
  const { setLoading } = usePageLoader();

  useEffect(() => {
    document.title = shiftSettingLabel.ManageStaff;
  }, []);

  const fetchStaffData = useCallback(() => {
    setLoading(true);
    manageStaffList(id, {
      ...selectedCenterPayload,
      selectedStaffSearch: searchWith,
      unselectedStaffSearch: searchWithout,
    })
      .then((res) => {
        if (checkStatusCodeSuccess(res.statusCode)) {
          setWithShift(res?.data?.selectedStaff || []);
          setWithoutShift(res?.data?.unselectedStaff || []);
        } else {
          setWithShift([]);
          setWithoutShift([]);
          toast.error(res?.message);
        }
      })
      .catch(() => {
        setWithShift([]);
        setWithoutShift([]);
      })
      .finally(() => setLoading(false));
  }, [id, searchWith, searchWithout, selectedCenterPayload, setLoading]);

  useEffect(() => {
    const t = setTimeout(fetchStaffData, 0);
    return () => clearTimeout(t);
  }, [fetchStaffData]);

  const toggle = (staff, isWith) => {
    const setter = isWith ? setWithShift : setWithoutShift;
    setter((prev) => prev.map((s) => (s.id === staff.id ? { ...s, selected: !s.selected } : s)));
  };

  const checkAll = (isWith) => {
    const list = isWith ? withShift : withoutShift;
    const setter = isWith ? setWithShift : setWithoutShift;
    const allOn = list.every((s) => s.selected);
    setter((prev) => prev.map((s) => ({ ...s, selected: !allOn })));
  };

  const getIds = (list, sel) => list.filter((s) => s.selected === sel).map((s) => s.id);

  const handleSave = () => {
    setBtnLoader(true);
    editManageStaff(id, {
      authIds: [...getIds(withShift, true), ...getIds(withoutShift, true)],
      unassignedUserIds: [...getIds(withShift, false), ...getIds(withoutShift, false)],
    })
      .then((res) => {
        if (checkStatusCodeSuccess(res.statusCode)) {
          toast.success(res?.message);
          navigate("/ShiftSetting");
        } else toast.error(res?.message);
      })
      .catch((err) => toast.error(err?.response?.data?.message || err?.message))
      .finally(() => setBtnLoader(false));
  };

  const totalSelected = getIds(withShift, true).length + getIds(withoutShift, true).length;

  return (
    <div className="animate-fade-in" style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div
        className="animate-slide-down"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 12,
              background: "rgba(16,185,129,0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Clock size={20} strokeWidth={1.75} style={{ color: "#10b981" }} />
          </div>
          <div>
            <h1
              style={{
                fontSize: "1.375rem",
                fontWeight: 800,
                margin: 0,
                color: "var(--text-primary)",
              }}
            >
              {shiftSettingLabel.ApplyShift}
            </h1>
            <p
              style={{ margin: 0, fontSize: "0.8125rem", color: "var(--text-muted)", marginTop: 2 }}
            >
              Select staff members to assign to this shift
            </p>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          {totalSelected > 0 && (
            <span
              style={{
                padding: "5px 12px",
                borderRadius: 999,
                fontSize: "0.75rem",
                fontWeight: 700,
                background: "rgba(99,102,241,0.1)",
                color: "var(--brand-indigo)",
              }}
            >
              {totalSelected} selected
            </span>
          )}
          <BackButton onClick={() => navigate("/ShiftSetting")} />
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
          gap: 16,
        }}
      >
        <StaffPanel
          title="Staff With This Shift"
          icon={UserCheck}
          iconColor="#10b981"
          iconBg="rgba(16,185,129,0.12)"
          items={withShift}
          searchValue={searchWith}
          onSearch={setSearchWith}
          onCheckAll={() => checkAll(true)}
          allChecked={withShift.length > 0 && withShift.every((s) => s.selected)}
          onToggle={(s) => toggle(s, true)}
          emptyMsg={notFound.dataNotFound}
          variant="with"
        />
        <StaffPanel
          title="Staff With Another Shift"
          icon={UserX}
          iconColor="#f43f5e"
          iconBg="rgba(244,63,94,0.12)"
          items={withoutShift}
          searchValue={searchWithout}
          onSearch={setSearchWithout}
          onCheckAll={() => checkAll(false)}
          allChecked={withoutShift.length > 0 && withoutShift.every((s) => s.selected)}
          onToggle={(s) => toggle(s, false)}
          emptyMsg={notFound.dataNotFound}
          variant="without"
        />
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", paddingBottom: 8 }}>
        <BaseButton color="primary" onClick={handleSave} loader={btnLoader} disabled={btnLoader}>
          {holidayLabel.Save}
        </BaseButton>
      </div>
    </div>
  );
};

export default ManageShiftStaff;
